<template>
  <div id="day">
    <el-card class="box-card tit">
      <div slot="header" class="clearfix">
        <span>统计查询&nbsp;/&nbsp;日报表统计</span>
      </div>
      <div>
        <Week @childFn="parentFn"></Week>
        <el-date-picker
          style="margin: 0 26px 0 0"
          v-model="zctime"
          type="daterange"
          value-format="yyyy-MM-dd"
          @blur="time"
          range-separator="至"
          start-placeholder="统计开始日期"
          end-placeholder="统计结束日期"
        >
        </el-date-picker>
        <el-button
          type="primary"
          element-loading-text="加载中..."
          element-loading-background="rgba(0, 0, 0, 0.4)"
          v-loading.fullscreen.lock="fullscreenLoading"
          @click="query"
          >查询</el-button
        >
        <el-button type="info" @click="reset">重置</el-button>
      </div>
    </el-card>
    <el-card class="box-card bdechart">
      <div slot="header" class="clearfix">
        <span>区域：{{ seekCity }}</span>
        <Screendata @choice="timec"></Screendata>
      </div>
      <div class="clearfix newbbtit">
        <span>日报表统计明细表</span>
        <Xlsx :name="formname"></Xlsx>
      </div>
      <el-table
        :data="tableData6"
        id="exportTab"
        border
        stripe
        :row-class-name="tableRowClassName"
        :sort-method="sortChange1"
        style="width: 100%"
      >
        <el-table-column prop="areaName" width="200" label="区域">
        </el-table-column>
        <el-table-column
          prop="dailyUserTotalInfo.total1"
          sortable
          min-width="120"
          label="新增乡厨数"
        >
        </el-table-column>
        <el-table-column
          prop="dailyUserTotalInfo.total2"
          sortable
          min-width="120"
          label="新增协管数"
        >
        </el-table-column>
        <el-table-column
          prop="dailyReportTotalInfo.total3"
          sortable
          min-width="120"
          label="新增报备数"
        >
        </el-table-column>
        <el-table-column
          prop="dailyReportTotalInfo.total4"
          sortable
          min-width="120"
          label="已审核数"
        >
        </el-table-column>
        <el-table-column
          prop="dailyReportTotalInfo.total5"
          sortable
          min-width="120"
          label="办宴场数"
        >
        </el-table-column>
        <el-table-column
          prop="dailyReportTotalInfo.total6"
          sortable
          min-width="120"
          label="办宴桌数"
        >
        </el-table-column>
        <el-table-column
          prop="dailyReportTotalInfo.total7"
          sortable
          min-width="120"
          label="参宴人数"
        >
        </el-table-column>
        <el-table-column
          prop="dailyReportTotalInfo.total8"
          sortable
          min-width="120"
          label="检查数"
        >
        </el-table-column>
      </el-table>
      <div class="paging">
        <span
          >共 <i class="pagingNum">{{ listnum }}</i> 条</span
        >
        <Paging :gopage="listnum" @pag="pag"></Paging>
      </div>
    </el-card>
  </div>
</template>
<script>
import Week from "@/components/Week";
import Screendata from "@/components/Screendata";
import Xlsx from "@/components/Xlsx";
import echarts from "echarts";
import Paging from "@/components/Paging";
export default {
  name: "day",
  components: {
    Week,
    Screendata,
    Xlsx,
    Paging,
  },
  data() {
    return {
      areaId: "",
      zctime: "",
      userdata: {},
      pageNum: 1,
      pageSize: 10,
      total: {}, //总计
      tableData6: [],
      stat: "", //定义一个查询
      listnum: 1,
      formname: JSON.stringify({ name: "日报表统计明细表", hint: "" }),
      fullscreenLoading: true,
      seekCity: "",
    };
  },
  created() {
    this.load();
    this.seekCity = this.userdata.areasName;
  },
  mounted() {},
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.areaName == "合计") {
        return "re";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    reset() {
      this.$router.push("/refresh");
    },
    pag(val) {
      this.pageNum = val.pageNum;
      this.pageSize = val.pageSize;
      this.fullscreenLoading = true;
      this.load();
    },
    sortChange1(a, b) {
      console.log(a, b);
    },
    load() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = {};
      let url = "";
      let newar = "";
      let newtime = "";
      if (this.zctime == "") {
        newtime = "";
      } else {
        newtime = this.zctime.join(",");
      }
      if (this.areaId == "") {
        newar = userdata.areasId;
        url = `/api-r/statistics/getDailyReportStaticsInitData`;
      } else {
        newar = this.areaId;
        url = `/api-r/statistics/getDailyReportStaticsData`;
      }
      if (this.stat == 1) {
        data = this.$qs.stringify({
          area: newar,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          time: newtime,
        });
      } else {
        data = this.$qs.stringify({
          area: userdata.areasId,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          time: newtime,
        });
        url = `/api-r/statistics/getDailyReportStaticsInitData`;
      }
      this.$axios
        .post(url, data, { headers: { accessToken: userdata.token } })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.success) {
            // console.log(res,'日报表')

            let arr = res.data.dailyReportStatisticsInfos;
            let obj = {
              areaName: "合计",
              dailyUserTotalInfo: { total1: "", total2: "" },
              dailyReportTotalInfo: {
                total3: "",
                total4: "",
                total5: "",
                total6: "",
                total7: "",
                total8: "",
              },
            };
            arr.forEach((x) => {
              obj.dailyUserTotalInfo.total1 =
                Number(obj.dailyUserTotalInfo.total1) +
                Number(x.dailyUserTotalInfo.total1);
              obj.dailyUserTotalInfo.total2 =
                Number(obj.dailyUserTotalInfo.total2) +
                Number(x.dailyUserTotalInfo.total2);
              obj.dailyReportTotalInfo.total3 =
                Number(obj.dailyReportTotalInfo.total3) +
                Number(x.dailyReportTotalInfo.total3);
              obj.dailyReportTotalInfo.total4 =
                Number(obj.dailyReportTotalInfo.total4) +
                Number(x.dailyReportTotalInfo.total4);
              obj.dailyReportTotalInfo.total5 =
                Number(obj.dailyReportTotalInfo.total5) +
                Number(x.dailyReportTotalInfo.total5);
              obj.dailyReportTotalInfo.total6 =
                Number(obj.dailyReportTotalInfo.total6) +
                Number(x.dailyReportTotalInfo.total6);
              obj.dailyReportTotalInfo.total7 =
                Number(obj.dailyReportTotalInfo.total7) +
                Number(x.dailyReportTotalInfo.total7);
              obj.dailyReportTotalInfo.total8 =
                Number(obj.dailyReportTotalInfo.total8) +
                Number(x.dailyReportTotalInfo.total8);
            });
            arr.push(obj);

            this.$set(this, "tableData6", arr);
            this.seekCity = res.data.mergerName;
            this.$set(this, "listnum", res.data.totalRecord);
            if (this.stat == 1) {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
            }
          }
        });
    },
    parentFn(i) {
      this.areaId = i.id;
      // this.seekCity = i.name
    },
    timec(i) {
      this.fullscreenLoading = true;
      this.pageNum = 1;
      let times = "";
      let d = new Date();
      let year = d.getFullYear();
      let mon = d.getMonth() + 1;
      let day = d.getDate();
      let nowtime = year + "-" + mon + "-" + day;
      if (i == 0) {
        times = `1970-01-01,${nowtime}`;
      } else {
        times = i;
      }
      let newar = "";
      if (this.areaId == "") {
        newar = this.userdata.areasId;
      } else {
        newar = this.areaId;
      }
      let data = this.$qs.stringify({
        area: newar,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        time: times,
      });
      let url = `/api-r/statistics/getDailyReportStaticsData`;
      this.$axios
        .post(url, data, { headers: { accessToken: this.userdata.token } })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.success) {
            this.$set(this, "tableData6", res.data.dailyReportStatisticsInfos);
            this.$set(this, "listnum", res.data.totalRecord);
            this.$message({
              type: "success",
              message: res.data.msg,
            });
          }
        });
    },
    time() {
      console.log(this.zctime);
    },
    query() {
      this.stat = 1;
      this.fullscreenLoading = false;
      this.load();
    },
  },
};
</script>
<style>
#day .tit .el-card__body {
  display: flex;
  align-items: center;
}
/* #day .el-pagination{
        margin:  22px 0;
        float: right
    } */
#day .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
#day .el-table th > .cell {
  font-size: 14px;
  color: #666;
}
/* 暂无数据样式 */
#day .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#day .el-pagination__sizes .el-select {
  margin-top: -12px;
}
#day .el-table .re {
  color: #11A983;
  font-weight: 800;
}
#day .el-select > .el-input {
  margin: 0px 0 18px;
}
</style>
<style scoped lang="scss">
.bdechart {
  width: 100% !important;
  margin-top: 24px;
}
.newbbtit {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
</style>
